import { trackEvent } from '../../../_common/client/tracking';
import { collapsedLinkClass } from './constants';

export const trackDimensionExpansion = (showMoreColorsLink: HTMLElement) => {
    const isCollapsed = showMoreColorsLink.classList.contains(collapsedLinkClass);
    trackEvent({ product_DimensionFold: isCollapsed ? 'more' : 'less' });
};
